import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';
import AboveFold from '../components/common/above-fold/AboveFold';
import PropertyTypesModule from '../modules/PropertyTypes/PropertyTypesModule';
import GreatPlacesToStayModule from '../modules/GreatPlacesToStay/GreatPlacesToStayModule';
import {DateModal} from '../components/common/date-modal/DateModal';
import ReviewsModule from '../components/common/review/ReviewsModule';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import {ScrollToTopButton} from '../components/ScrollToTopButton';
import {AsyncRecentTravelerActivity} from '../components/common/recent-traveler-activity/AsyncRecentTravelerActivity';
import {TESTS} from '../utils/abacus';
import {AsyncToaster} from '../components/common/toaster/AsyncToaster';
import {AsyncTripBoardModal} from '../components/common/tripboard/AsyncTripBoardModal';
import {AsyncRecommendedProperties} from '../components/destination/recommended-properties/AsyncRecommendedProperties';
import SEOTextModule from '../components/destination/seo-text/SEOTextModule';
import {AsyncAATestModule} from '../modules/AATest/AsyncAATestModule';
import {
    fullExposures,
    lazy,
    withErrorBoundary,
    withTripboardsLazy,
    withTripboards,
} from './helpers';

export const fullExposureTests = [
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.SLP_TRAFFIC_TEST_AA,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HEADING_TRAFFIC,
    TESTS.HEADING_CONVERSION,
    TESTS.ROADTRIPS_SITE_NAVIGATION,
    TESTS.ROADTRIPS_SITE_NAVIGATION_NEW_LABEL,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
];

function TemplateComponent(props) {
    const {isMobile, hasTouch, dispatch, hasMABData, showPlaceholders} = props;

    useEffect(() => {
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }, [isMobile, hasTouch, dispatch]);

    const mainCSSClass = classNames('app-main', 'module--no-padding', {
        'container--loading__visible': showPlaceholders,
    });

    const mabTest = hasMABData ? [TESTS.HA_PTA_LANDING_SLPHEROMAB] : [];

    return (
        <>
            <main className={mainCSSClass}>
                {fullExposures([...fullExposureTests, ...mabTest])}
                <AboveFold />
                {withTripboardsLazy(<AsyncRecentTravelerActivity />)}
                {withTripboardsLazy(<AsyncRecommendedProperties />)}
                {lazy(<AsyncAATestModule />)}
                {withTripboards(<GreatPlacesToStayModule />)}
                {withTripboards(<ReviewsModule />)}
                {withErrorBoundary(<PropertyTypesModule />)}
                {withErrorBoundary(<SEOTextModule />)}
                {lazy(<ScrollToTopButton />)}
                {withErrorBoundary(<DateModal />)}
            </main>
            {withErrorBoundary(<DynamicSeoLinkpile forceExpanded />)}
            {withErrorBoundary(<AsyncToaster />)}
            {withErrorBoundary(<AsyncTripBoardModal />)}
        </>
    );
}

export function mapStateToProps({mab = {}, options}) {
    return {
        hasMABData: !!mab.arm,
        showPlaceholders: options.showPlaceholders,
    };
}

export const Template = connect(mapStateToProps)(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
